import React from 'react';

import {Shipping, Calendar, Icon, MoneyBack, Home} from '@optimaxdev/icons';
import classNames from 'classnames';

import {useFeature} from 'components/feature';

import {PointsInfoTooltip} from '../pointsInfoTooltip/pointsInfoTooltip';

import s from './pointsInfo.scss';

const getPoints = (isFacelift: boolean) => {
    const HOME_TRY_ON_POINT = {
        analyticsTitle: '14-day home try-on',
        className: s.homeWrap,
        contentClassName: s.home,
        description: {
            caption: '14-day home try-on',
            content:
                'At GlassesUSA.com, return and exchanges are made easy. We do our best to make returns and exchanges as easy as possible. We are pretty confident that you’ll love our product. Howewer, if for some reason or other you’re not completely satisfied with your glasses within the first 14 days of receiving them, you are entitled to a money back return or 100% store credit. No questions asked and hassle-free.',
        },
        icon: Home,
        offset: 50,
        title: '14-day home try-on',
    };

    return [
        {
            analyticsTitle: 'Free Shipping & Returns',
            className: classNames(s.trackWrap, {[s.trackWrapFacelift]: isFacelift}),
            contentClassName: classNames(s.track, {[s.trackFacelift]: isFacelift}),
            description: {
                caption: 'Free Shipping & Returns',
                content: (
                    <>
                        <p className={classNames({[s.textFacelift]: isFacelift})}>
                            Enjoy free shipping and returns on all orders - no minimum required.
                        </p>
                        <a
                            className={classNames(s.link, {[s.linkFacelift]: isFacelift})}
                            href="/terms-and-conditions#RETURNPOLICY"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Read our full return policy.
                        </a>
                    </>
                ),
            },
            icon: Shipping,
            offset: 50,
            title: 'Free shipping & returns',
        },
        ...(isFacelift ? [HOME_TRY_ON_POINT] : []),
        {
            analyticsTitle: 'Warranty',
            className: s.calendarWrap,
            contentClassName: classNames(s.calendar, {[s.calendarFacelift]: isFacelift}),
            description: {
                caption: '365 Day Warrant',
                content:
                    "All of our glasses come with a standard 365‑day manufacture's warranty on frames and lenses.",
            },
            icon: Calendar,
            offset: 45,
            title: '365 day warranty',
        },
        {
            analyticsTitle: 'Money Back Guarantee',
            className: s.dollarWrap,
            contentClassName: classNames(s.dollar, {[s.dollarFacelift]: isFacelift}),
            description: {
                caption: 'Money Back Guaranteed',
                content:
                    'We’re confident you’ll love your new glasses. If for any reason you’re not completely satisfied within the first 14 days, you’re entitled to a full refund or a 100% store credit, no questions asked.',
            },
            icon: MoneyBack,
            offset: 15,
            title: '100% money-back guarantee',
        },
    ] as const;
};

/**
 * Points Info for checkout page
 *
 * @constructor
 */
export const PointsInfo: React.FC = () => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <ul className={s.wrapper}>
            {getPoints(isFacelift).map(
                ({
                    analyticsTitle,
                    className,
                    contentClassName,
                    description: {caption, content},
                    icon,
                    offset,
                    title,
                }) => {
                    return (
                        <li className={classNames(s.item, className)} key={title}>
                            <div className={s.iconWrapper}>
                                <Icon className={s.icon} icon={icon} />
                            </div>

                            <PointsInfoTooltip
                                analyticsTitle={analyticsTitle}
                                caption={caption}
                                content={content}
                                contentClassName={contentClassName}
                                offset={offset}
                                title={title}
                            />
                        </li>
                    );
                },
            )}
        </ul>
    );
};
